import type { DashboardSalesStats } from '../services/dashboardService'

export function dashboardHasSalesData(stats: DashboardSalesStats | null | undefined): boolean {
  if (!stats) return false
  return Boolean(stats.hasActivity)
}
